<div class="h-full mt-24px pb-[100px] px-12px custom-filter">
	<div class="flex justify-between items-center">
		<h1 class="tw-font-bold mb-0 font-semibold text-[24px]">
			{{ 'GENERAL_LABELS.FILTRATION' | translate }}
		</h1>
		<button *ngIf="filterCount" (click)="resetFilter()" class="flex text-link">
			{{ 'ACTIONS.RESET' | translate }}
			<img
				class="align-middle mx-2"
				src="assets/images/icon-reset.svg"
				alt="icon"
			/>
		</button>
	</div>
	<div class="mt-24px">
		<p class="text-[18px] ltr:font-DIN-Bold font-bold rtl:font-medium">
			{{ 'GENERAL_LABELS.DATE_RANGES' | translate }}
		</p>
		<div>
			<app-custom-datepicker
				class="w-[49%]"
				[defaultValue]="getController('fromDate')?.value"
				label="GENERAL_LABELS.START_DATE"
				(dateValue)="getController('fromDate')?.setValue($event)"
			></app-custom-datepicker>
			<app-custom-datepicker
				class="w-[49%]"
				[defaultValue]="getController('toDate')?.value"
				label="GENERAL_LABELS.END_DATE"
				(dateValue)="getController('toDate')?.setValue($event)"
			></app-custom-datepicker>
		</div>

		<mat-error>
			<div
				class="whitespace-nowrap"
				*ngIf="
					getController('toDate')?.value < getController('fromDate')?.value &&
					getController('toDate')?.value
				"
			>
				{{ 'VALIDATION.END_DATE_ERROR' | translate }}
			</div>
		</mat-error>

		<div class="w-100 h-[1px] bg-secondry-color-Gray my-24px"></div>
		<div>
			<p class="text-[18px] ltr:font-DIN-Bold font-bold rtl:font-medium">
				{{ 'WALLET.WALLET_LIST.ORGSNAME' | translate }}
			</p>
			<mat-form-field
				[dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'"
				class="w-full"
				appearance="outline"
				(click)="showList = !showList"
			>
				<mat-label>{{
					'GENERAL_LABELS.SEARCH_ORGSNAME' | translate
				}}</mat-label>
				<input type="text" matInput [formControl]="keyWord" />
				<img
					*ngIf="!keyWord?.value"
					class="w-3 cursor-pointer absolute ltr:right-6 rtl:left-6 top-[22px]"
					src="assets/images/arrow.png"
				/>

				<img
					(click)="keyWord.setValue('')"
					*ngIf="keyWord?.value"
					src="./assets/images/close-square.svg"
					class="cursor-pointer absolute ltr:right-4 rtl:left-4 top-[15px]"
				/>
			</mat-form-field>
			<ul class="autoCompleteList" *ngIf="showList">
				<li
					*ngFor="let name of serviceProviders"
					(click)="
						getController('organizationId').setValue(name.id);
						keyWord.setValue(name?.name);
						getBranches();
						showList = !showList
					"
				>
					{{ name?.name }}
				</li>
				<li *ngIf="!serviceProviders?.length && showList" class="text-center">
					{{ 'GENERAL.NO_BUSINESS_NAME_FOUND' | translate }}
				</li>
			</ul>
		</div>
		<div class="w-100 h-[1px] bg-secondry-color-Gray my-24px"></div>
		<div>
			<p class="text-[18px] ltr:font-DIN-Bold font-bold rtl:font-medium">
				{{ 'BOOKING.BOOKING_DETAILS.BRANCH_NAME' | translate }}
			</p>
			<mat-form-field
				[dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'"
				class="w-full"
				appearance="outline"
				(click)="showBranchList = !showBranchList"
			>
				<mat-label>{{
					'GENERAL_LABELS.SEARCH_BRANCH_NAME' | translate
				}}</mat-label>
				<input type="text" matInput [formControl]="keyWordBranch" />
				<img
					*ngIf="!keyWordBranch?.value"
					class="w-3 cursor-pointer absolute ltr:right-6 rtl:left-6 top-[22px]"
					src="assets/images/arrow.png"
				/>

				<img
					(click)="keyWordBranch.setValue('')"
					*ngIf="keyWordBranch?.value"
					src="./assets/images/close-square.svg"
					class="cursor-pointer absolute ltr:right-4 rtl:left-4 top-[15px]"
				/>
			</mat-form-field>
			<ul class="autoCompleteList" *ngIf="showBranchList">
				<li
					*ngFor="let name of branchesList"
					(click)="
						getController('branchId').setValue(name.id);
						keyWordBranch.setValue(name?.name);
						getBranches();
						showBranchList = !showBranchList
					"
				>
					{{ name?.name }}
				</li>
				<li *ngIf="!branchesList?.length && showBranchList" class="text-center">
					{{ 'GENERAL.BRANCH_NAME_FOUND' | translate }}
				</li>
			</ul>
		</div>
		<div class="mb-36px">
			<p
				class="text-dark-grey text-font-18 ltr:font-DIN-Bold font-bold rtl:font-medium leading-[22px]"
			>
				{{ 'BOOKING.BOOKING_DETAILS.PAYMENT_STATUS' | translate }}
			</p>

			<div
				*ngFor="let paymentArrayy of paymentMethodEnum; let i = index"
				class="flex justify-between border-[1px] border-[#D9DBE9] rounded-12px my-auto p-4 mb-2"
			>
				<div class="h-[24px]">
					<mat-checkbox
						(change)="paymentChanged($event, 'payoutMethodId')"
						[value]="paymentArrayy?.value"
						class="ltr:mr-2 rtl:ml-2 mb-[19px]"
						[checked]="
							getController('payoutMethodId')?.value?.includes(
								paymentArrayy?.value
							)
						"
					>
					</mat-checkbox>
					{{ 'STATUS.' + paymentArrayy['name'].toUpperCase() | translate }}
				</div>

				<img
					class="{{ i == 0 ? 'w-[24px] h-[24px]' : '' }}"
					src="assets/images/{{
						i == 0 ? 'bank' : i == 1 ? 'Fawri' : 'instapay'
					}}.{{ i == 0 ? 'png' : 'svg' }}"
					alt=""
					srcset=""
				/>
			</div>
		</div>
		<button
			[disabled]="
				filterCount == 0 ||
				(getController('toDate').value < getController('fromDate').value &&
					getController('toDate').value)
			"
			class="bg-gradient text-white w-[89%] p-0 absolute bottom-5"
			mat-button
			(click)="submit()"
		>
			{{ 'ACTIONS.APPLY_FILTER' | translate }}
		</button>
	</div>
</div>
